import React from "react";
import PublicArticleList from "./PublicArticleList";

export default function Stories() {
  return (
    <PublicArticleList
      kind="short_story"
      overline="Short Stories"
      title="The smaller pieces."
      lede="Character origin stories and shorts set in the world of The Boggin Chronicles. Read in any order. Each one self-contained."
      emptyTitle="No stories have been posted yet."
      emptyNote="They are being copied out properly before release."
      dataTestid="public-stories"
      baseRoute="/stories"
      heroImage={{
        src: "/images/book-pyre-transparent.png",
        alt: "Five young orc children sitting cross-legged on a woven rug, dressed in simple white tunics, leaning in rapt attention — one grinning wide, one wide-eyed, one open-mouthed in wonder — while listening to an unseen storyteller.",
        caption: "Stories passed down round the fire — before they ever reached the page.",
      }}
    />
  );
}
